(() => {
  const root = document.querySelector('[data-wedding-prices]');
  if (!root) return;

  const data = {
    30: {
      label: '30',
      title: 'Start with a larger 2-tier cake.',
      copy: 'A 2-tier 8″ + 10″ cake serves approximately 35 using our standard serving guide.',
      size: '30',
      target: '#wpp-size-30'
    },
    50: {
      label: '50',
      title: 'Start with the larger 3-tier format.',
      copy: 'A 3-tier 8″ + 10″ + 12″ cake serves approximately 63, giving useful breathing room for around 50 guests.',
      size: '50',
      target: '#wpp-size-50'
    },
    80: {
      label: '80',
      title: 'Start with a 4-tier cake.',
      copy: 'A 4-tier 6″ + 8″ + 10″ + 12″ cake serves approximately 84 using our standard serving guide.',
      size: '80',
      target: '#wpp-size-80'
    },
    120: {
      label: '120+',
      title: 'Use a display cake plus cutting cakes.',
      copy: 'For larger weddings, keeping the visible cake elegant and adding simple cutting cakes is usually more practical than making every display tier larger.',
      size: '80',
      target: '#wpp-cutting'
    }
  };

  const label = root.querySelector('[data-wpp-result-label]');
  const title = root.querySelector('[data-wpp-result-title]');
  const copy = root.querySelector('[data-wpp-result-copy]');
  const resultLink = root.querySelector('[data-wpp-result-link]');

  root.querySelectorAll('[data-wpp-guests]').forEach((button) => {
    button.addEventListener('click', () => {
      const key = Number(button.dataset.wppGuests);
      const item = data[key];
      if (!item) return;

      root.querySelectorAll('[data-wpp-guests]').forEach((other) => {
        const active = other === button;
        other.classList.toggle('is-active', active);
        other.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      if (label) label.textContent = item.label;
      if (title) title.textContent = item.title;
      if (copy) copy.textContent = item.copy;
      if (resultLink && item.target) resultLink.setAttribute('href', item.target);

      root.querySelectorAll('[data-wpp-size]').forEach((row) => {
        row.classList.toggle('is-recommended', row.dataset.wppSize === item.size);
      });
    });
  });

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });

    root.querySelectorAll('.wpp-reveal').forEach((el) => observer.observe(el));
  } else {
    root.querySelectorAll('.wpp-reveal').forEach((el) => el.classList.add('is-visible'));
  }
})();